import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Table } from "reactstrap";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function EquipDetail() {
  document.title = "Equipment Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const isAdmin = searchParams.get("admin");
  const equipId = location.state?.equipData?.data?.id;
  const [equipData, setEquipData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );
  const fetchEquip = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.equip}/${id}`);
      setEquipData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching equip data:", error);
      setEquipData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (equipId) {
      fetchEquip(equipId);
    }
  }, [equipId]);

  const handleEditEquip = () => {
    if (equipData) {
      navigate(`/edit-equip/${equipId}${isAdmin ? "?admin=true" : ""}`);
    }
  };

  const handleDeleteEquip = async () => {
    try {
      await del(`${endpoints.equip}/${equipId}`);
      toast.success("Equip Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate(
        `/equip-listing?equipId=${equipId}&gymId=${equipData?.gym?.id}${
          isAdmin ? "&admin=true" : ""
        }`
      );
    } catch (error) {
      console.error("Error deleting equip:", error);
    }
  };

  return (
    <>
      <div className="">
        <Container fluid>
          <Card className="rounded-4 p-4">
            <Row className="justify-content-between align-items-center">
              <Col md={6}>
                <h2 className="fw-bold font-size-20 ff-sora primary-black">
                  Equipment Details
                </h2>
              </Col>
              <Col md={6} xs={12} className="d-flex justify-content-end">
                {userPermissions?.equipment?.["Delete Equipment"] && (
                  <Button
                    color="white"
                    className="me-2 rounded-pill1"
                    onClick={handleDeleteEquip}
                  >
                    Delete Equipment
                  </Button>
                )}
                {userPermissions?.equipment?.["Update Equipment"] && (
                  <Button className="rounded-pill" onClick={handleEditEquip}>
                    Edit Equipment
                  </Button>
                )}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <span className="font-size-16 fw-normal fw-bold ff-sora secondary-black">
                  General Info
                </span>

                <div
                  className="table-responsive hide-scrollbar rounded-4"
                  style={{ height: "500px" }}
                >
                  {loading ? (
                    <div className="text-center ff-sora fw-normal font-size-16">
                      Loading...
                    </div>
                  ) : equipData ? (
                    <Table
                      className="table table-borderless"
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <tbody style={{ minHeight: "550px" }}>
                        <tr>
                          <td>
                            {equipData.file ? (
                              <img
                                src={`${process.env.REACT_APP_IMG_URL}${equipData.file}`}
                                className="rounded-3 object-fit-cover mt-1"
                                style={{
                                  height: "200px",
                                  width: "230px",
                                }}
                                alt={`gym-image`}
                              />
                            ) : (
                              <p>No image available</p>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="font-size-16 fw-normal ff-sora light-black"
                            style={{ color: "#9e9e9e", width: "60%" }}
                          >
                            Name
                          </td>
                          <td
                            className="font-size-16 fw-normal ff-sora secondary-black text-capitalize"
                            style={{ width: "60%", color: "#525252" }}
                          >
                            {equipData.name}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className=" font-size-16 fw-normal ff-sora"
                            style={{ color: "#9e9e9e" }}
                          >
                            Category
                          </td>
                          <td
                            className="font-size-16 fw-normal ff-sora secondary-black"
                            style={{ color: "#525252" }}
                          >
                            {equipData.category}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="font-size-16 fw-normal ff-sora light-black"
                            style={{ color: "#9e9e9e" }}
                          >
                            Brand
                          </td>
                          <td
                            className="font-size-16 fw-normal ff-sora secondary-black"
                            style={{ color: "#525252" }}
                          >
                            {equipData.brand}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : (
                    <div
                      className=" text-center font-size-16 fw-normal ff-sora secondary-black"
                      style={{ color: "#525252" }}
                    >
                      No equip data available
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </Container>
      </div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "0px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </>
  );
}
